import { api } from "../../../api";

export class CMDBService {
  async fetchServerStats() {
    return await api("/cmdb/servers/stats");
  }

  async fetchServers({ limit = 50, offset = 0, search, status } = {}) {
    const params = new URLSearchParams();
    if (limit !== undefined && limit !== null) params.set("limit", String(limit));
    if (offset !== undefined && offset !== null) params.set("offset", String(offset));
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    return await api(`/cmdb/servers?${params}`);
  }

  async fetchTopology() {
    return await api("/cmdb/topology");
  }

  async fetchAssetHealthSummary(period = "7d") {
    return await api(`/cmdb/asset-health-summary?period=${period}`);
  }

  async fetchAssetHealthTrend(period = "24h") {
    return await api(`/cmdb/asset-health-trend?period=${period}`);
  }

  async fetchApplicationTree() {
    return await api("/cmdb/applications/tree");
  }

  async fetchApplicationSummary() {
    return await api("/cmdb/applications/summary");
  }

  async fetchApplicationHealthAnalytics(period = "7d") {
    return await api(`/cmdb/applications/health-analytics?period=${period}`);
  }

  async fetchApplications(activeOnly = true) {
    return await api(`/cmdb/applications?active_only=${activeOnly}`);
  }

  async createApplication(data) {
    return await api("/cmdb/applications", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateApplication(id, data) {
    return await api(`/cmdb/applications/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async deleteApplication(id) {
    return await api(`/cmdb/applications/${id}`, {
      method: "DELETE",
    });
  }

  async attachServicesToApplication(appId, serviceIds, relationType = "owner") {
    return await api(`/cmdb/applications/${appId}/services`, {
      method: "POST",
      body: JSON.stringify({ service_ids: serviceIds, relation_type: relationType }),
    });
  }

  async detachServiceFromApplication(appId, serviceId) {
    return await api(`/cmdb/applications/${appId}/services/${serviceId}`, {
      method: "DELETE",
    });
  }

  async fetchServerServices(serverId) {
    return await api(`/cmdb/servers/${serverId}/services`);
  }

  async fetchBlastRadius(serviceId, maxDepth = 5) {
    return await api(`/cmdb/services/${serviceId}/blast-radius?max_depth=${maxDepth}`);
  }
}

export const cmdbService = new CMDBService();

export const fetchServerStats = () => cmdbService.fetchServerStats();
export const fetchServers = (params) => cmdbService.fetchServers(params);
export const fetchTopology = () => cmdbService.fetchTopology();
export const fetchAssetHealthSummary = (period) => cmdbService.fetchAssetHealthSummary(period);
export const fetchAssetHealthTrend = (period) => cmdbService.fetchAssetHealthTrend(period);
export const fetchApplicationTree = () => cmdbService.fetchApplicationTree();
export const fetchApplicationSummary = () => cmdbService.fetchApplicationSummary();
export const fetchApplicationHealthAnalytics = (period) => cmdbService.fetchApplicationHealthAnalytics(period);
export const fetchApplications = (activeOnly) => cmdbService.fetchApplications(activeOnly);
export const createApplication = (data) => cmdbService.createApplication(data);
export const updateApplication = (id, data) => cmdbService.updateApplication(id, data);
export const deleteApplication = (id) => cmdbService.deleteApplication(id);
export const attachServicesToApplication = (appId, serviceIds, relationType) => cmdbService.attachServicesToApplication(appId, serviceIds, relationType);
export const detachServiceFromApplication = (appId, serviceId) => cmdbService.detachServiceFromApplication(appId, serviceId);
export const fetchServerServices = (serverId) => cmdbService.fetchServerServices(serverId);
export const fetchBlastRadius = (serviceId, maxDepth) => cmdbService.fetchBlastRadius(serviceId, maxDepth);

